import { Spacer } from 'foundations-components/components/Spacer';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ContainerTemplate({
  description,
  children
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Paragraph, {
      color: "text-core-subtle",
      children: description
    }), children, /*#__PURE__*/_jsx(Spacer, {
      space: "600"
    })]
  });
}